// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"064b6111","298":"a1745e63","616":"967c8863"}[chunkId] + ".chunk.js";
};